import { validatePhoneNumber } from '@/lib/validation/phoneValidation';
import z from 'zod';

export const invitePractitionerSchema = z.object({
  name: z.string().min(1, 'First name is required'),
  surname: z.string().min(1, 'Last name is required'),
  email: z.string().email('Invalid email address'),
  clinic: z.string().min(1, 'Please select a clinic'),
  phone: z
    .string()
    .min(1, 'Phone number is required')
    .refine((val) => validatePhoneNumber(val), {
      message: 'Invalid phone number format',
    }),
});

export type InvitePractitionerFormValues = z.infer<
  typeof invitePractitionerSchema
>;
